import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GoodgovernenceService } from 'src/app/services/goodgovernence.service';

@Component({
  selector: 'app-compliance-good-governence',
  templateUrl: './compliance-good-governence.component.html',
  styleUrls: ['./compliance-good-governence.component.scss']
})

export class ComplianceGoodGovernenceComponent implements OnInit {
  language = JSON.parse(localStorage.getItem('language'))
  titleDropdown = 'เลือกกองทุน'
  valueDropdown = [
    {
      id: 1,
      value: 'นโยบายธรรมาภิบาลการลงทุน'
    },
    {
      id: 2,
      value: 'จรรยาบรรณ'
    },
    {
      id: 3,
      value: 'นโยบายต่อต้านคอร์รัปชั่น'
    },
    {
      id: 4,
      value: 'หลักธรรมาภิบาลเกี่ยวกับผลิตภัณฑ์กองทุนรวม'
    }
  ];

  private navigateTo: any
  choiceFromSelect: string
  newsDate: any;

  totalNewsPage_announce: number;
  announce: any;
  renderAnnounce: any;
  newsCurrentPage_announce: number = 1;

  flag: any

  constructor(private route: ActivatedRoute, private _goodgovernenceService: GoodgovernenceService) { }

  ngOnInit() {

    this.flag = localStorage.getItem("language_flag")

    this.navigateTo = this.route.params.subscribe(params => {
      if (params['type'] === 'option1') {
        this.choiceFromSelect = params['type']
        this.titleDropdown = 'นโยบายธรรมาภิบาลการลงทุน'
        this._goodgovernenceService.get_GoodgovernenceList().subscribe(response => {
          this.announce = response;
          this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
          this.setRenderNewsPerpage_announce(this.announce);
        })
      }
      else if (params['type'] === 'option2') {
        this.choiceFromSelect = params['type']
        this.titleDropdown = 'จรรยาบรรณ'
        this._goodgovernenceService.get_ethicList().subscribe(response => {
          this.announce = response;
          this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
          this.setRenderNewsPerpage_announce(this.announce);
        })


      }
      else if (params['type'] === 'option3') {
        this.choiceFromSelect = params['type']
        this.titleDropdown = 'นโยบายต่อต้านคอร์รัปชั่น'
        this._goodgovernenceService.get_corruptionList().subscribe(response => {
          this.announce = response;
          this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
          this.setRenderNewsPerpage_announce(this.announce);
        })
      }
      else if (params['type'] === 'option4') {
        this.choiceFromSelect = params['type']
        this.titleDropdown = 'หลักธรรมาภิบาลเกี่ยวกับผลิตภัณฑ์กองทุนรวม'
        this._goodgovernenceService.get_productList().subscribe(response => {
          this.announce = response;
          this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
          this.setRenderNewsPerpage_announce(this.announce);
        })
      }
    })
  }

  setTotalNewsPage_announce(announceList) {
    if (announceList.length <= 10) {
      return 1;
    } else {
      return Math.ceil(announceList.length / 10);
    }
  }

  setRenderNewsPerpage_announce(announceList) {
    if (announceList === undefined) {
      return null;
    } else {
      this.renderAnnounce = announceList.slice(this.newsCurrentPage_announce * 10 - 10,
        this.newsCurrentPage_announce * 10);
    }
  }

  setCurrentNewsPage_announce(event) {
    this.newsCurrentPage_announce = event;
    this.setRenderNewsPerpage_announce(this.announce);
  }

  changeFormatDate_dd(date) {
    if (date === '') {
      return null;
    } else {
      return this.newsDate = this._goodgovernenceService.changeFormatDate_dd(date);
    }
  }

  changeFormatDate_mm(date) {
    if (date === '') {
      return null;
    } else {
      return this.newsDate = this._goodgovernenceService.changeFormatDate_MM(date);
    }
  }

  changeFormatDate_yy(date) {
    if (date === '') {
      return null;
    } else {
      return this.newsDate = this._goodgovernenceService.changeFormatDate_yy(date);
    }
  }

  date_thai(date) {
    if (date === '') {
      return null;
    } else {
      return this.newsDate = this._goodgovernenceService.date_thai(date);
    }
  }

  date_thai_dd(date) {
    if (date === '') {
      return null;
    } else {
      return this.newsDate = this._goodgovernenceService.date_thai_dd(date);
    }
  }

  date_thai_mm(date) {
    if (date === '') {
      return null;
    } else {
      return this.newsDate = this._goodgovernenceService.date_thai_mm(date);
    }
  }

  date_thai_yy(date) {
    if (date === '') {
      return null;
    } else {
      return this.newsDate = this._goodgovernenceService.date_thai_yy(date);
    }
  }

  selectValue(event) {
    if (event == 1) {
      this._goodgovernenceService.get_GoodgovernenceList().subscribe(response => {
        this.announce = response;
        this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
        this.setRenderNewsPerpage_announce(this.announce);
      })
    } else if (event == 2) {
      this._goodgovernenceService.get_ethicList().subscribe(response => {
        this.announce = response;
        this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
        this.setRenderNewsPerpage_announce(this.announce);
      })
    }
    else if (event == 3) {
      this._goodgovernenceService.get_corruptionList().subscribe(response => {
        this.announce = response;
        this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
        this.setRenderNewsPerpage_announce(this.announce);
      })
    }
    else if (event == 4) {
      this._goodgovernenceService.get_productList().subscribe(response => {
        this.announce = response;
        this.totalNewsPage_announce = this.setTotalNewsPage_announce(this.announce);
        this.setRenderNewsPerpage_announce(this.announce);
      })
    }
  }
}
